"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serviceTypeTransitions = exports["default"] = void 0;

var _ServiceState = _interopRequireDefault(require("./ServiceState"));

var ServiceType = {
  LOCAL: 'LOCAL',
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE'
};
exports["default"] = ServiceType;
var localServiceLifeCycle = {
  CREATED: [_ServiceState["default"].INITIALIZING],
  INITIALIZING: [_ServiceState["default"].CREATED, _ServiceState["default"].READY],
  READY: [_ServiceState["default"].ERROR],
  ERROR: []
};
var publicServiceLifeCycle = {
  CREATED: [_ServiceState["default"].INITIALIZING],
  INITIALIZING: [_ServiceState["default"].CREATED, _ServiceState["default"].OFFLINE],
  OFFLINE: [_ServiceState["default"].CONNECTING],
  CONNECTING: [_ServiceState["default"].OFFLINE, _ServiceState["default"].READY],
  READY: [_ServiceState["default"].OFFLINE, _ServiceState["default"].ERROR],
  ERROR: []
};
var privateServiceLifeCycle = {
  CREATED: [_ServiceState["default"].INITIALIZING],
  INITIALIZING: [_ServiceState["default"].CREATED, _ServiceState["default"].OFFLINE],
  OFFLINE: [_ServiceState["default"].CONNECTING],
  CONNECTING: [_ServiceState["default"].OFFLINE, _ServiceState["default"].ONLINE],
  ONLINE: [_ServiceState["default"].OFFLINE, _ServiceState["default"].AUTHENTICATING],
  AUTHENTICATING: [_ServiceState["default"].ONLINE, _ServiceState["default"].READY],
  READY: [_ServiceState["default"].OFFLINE, _ServiceState["default"].ONLINE, _ServiceState["default"].ERROR],
  ERROR: []
};
var serviceTypeTransitions = {
  LOCAL: localServiceLifeCycle,
  PUBLIC: publicServiceLifeCycle,
  PRIVATE: privateServiceLifeCycle
};
exports.serviceTypeTransitions = serviceTypeTransitions;